import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _, { first } from 'lodash';
import { Autocomplete, AutocompleteChangeDetails, Grid, TextField } from '@mui/material';

interface DwtSelectorProp {
    value: number,
    className?: string,
    onChange?: (value: number) => void,
}

interface UpdatedDateOption {
    value: number,
    text: string
}

const UpdatedDateSelector: React.FunctionComponent<DwtSelectorProp> = (props) => {
    const dispatch = useDispatch();
    const [defaultOptions, setDefaultOptions] = useState<UpdatedDateOption[]>([]);

    useEffect(() => {
        let options = [];
        for (let index = 1; index <= 10; index++) {
            options.push({
                value: index,
                text: index + " days ago"
            } as UpdatedDateOption);
        }

        setDefaultOptions(options);
    }, [])

    const getUpdatedOption = (value: number): UpdatedDateOption | null => {
        let selectedOption = _.find(defaultOptions, (option) => {
            return option.value === value;
        });

        return selectedOption ? selectedOption : null;
    }

    return (
        <>
            <Autocomplete
                options={defaultOptions}
                renderInput={(params) => <TextField {...params} label="Updated Time" />}
                className={props.className ? props.className : ""}
                value={getUpdatedOption(props.value)}
                getOptionLabel={(option: UpdatedDateOption) => {
                    return option.text;
                }}
                onChange={(event: React.SyntheticEvent, value: UpdatedDateOption | null, reason: string, details?: AutocompleteChangeDetails<UpdatedDateOption> | undefined) => {
                    let selectedValue = value ? value.value : 0;

                    if (props.onChange) {
                        props.onChange(selectedValue);
                    }
                }}
            />
        </>
    )
};

export default UpdatedDateSelector;